<template>
  <div>
    <div class="center-title">
      <div class="flex">
        <img v-if="curInfo.IconFull" :src="api + curInfo.IconFull" alt class="center-icon" />
        <div v-else class="center-icon-default">
          <span>{{ userName }}</span>
        </div>
        <div>
          <p class="center-name">{{ curInfo.FullName }}</p>
          <p class="center-username">{{ curInfo.UserName }}</p>
        </div>
      </div>
    </div>
    <div class="center-content">
      <van-cell-group>
        <van-cell title="性别" :value="curInfo.Sex === 1 ? '男' : '女'" />
        <van-cell title="手机号" :value="curInfo.PhoneNumber ? curInfo.PhoneNumber : '未填写'" />
      </van-cell-group>
      <van-cell-group class="van-cell-group-edit">
        <van-cell title="修改密码" is-link @click="isPwd = true" />
        <van-cell title="绑定/解绑微信" is-link @click="isWeChat = true" />
      </van-cell-group>
      <div class="center-out" @click="signOut">退出登录</div>
    </div>
    <center-pwd :isPwd="isPwd" @listenToPwd="listenToPwd"></center-pwd>
    <we-chat :isWeChat="isWeChat" @listenToWeChat="listenToWeChat"></we-chat>
  </div>
</template>
<script>
import CenterPwd from "@/pages/common/views/xy/parent/CenterChangePwd";
import WeChat from "@/pages/common/views/xy/parent/CenterWeChat";
export default {
  name: "center",
  components: {
    CenterPwd,
    WeChat
  },
  data() {
    return {
      api: "",
      curInfo: {},
      isPwd: false,
      isWeChat: false,
      userName: "",
      reg: /^[A-Za-z0-9]+$/,
      regNumber: /\d+/
    };
  },
  created() {
    this.api = this.xyMApi;
    this.curInfo = this.$store.state.parentInfo.userInfo;
    if (this.reg.test(this.curInfo.FullName) || this.regNumber.test(this.curInfo.FullName)) {
      this.userName = this.curInfo.FullName.substring(0, 2);
    } else {
      if (this.curInfo.FullName.length > 2) {
        this.userName = this.curInfo.FullName.substring(this.curInfo.FullName.length - 2);
      } else {
        this.userName = this.curInfo.FullName.substring(0, 2);
      }
    }
  },
  methods: {
    listenToPwd(val) {
      // 监听修改密码组件
      this.isPwd = val;
    },
    listenToWeChat(val) {
      // 监听修改微信组件
      this.isWeChat = val;
    },
    signOut() {
      this.xy.confirm("温馨提示", "您确认要退出吗？", () => {
        localStorage.clear();
        //this.$store.commit("parentInfo/addChildData", ""); //置空当前已选的孩子
        this.$store.commit("parentInfo/resetState");
        this.xy.removeCookie(".XYTOKEN");
        this.$router.push("/");
      });
    }
  }
};
</script>
<style lang="less" scoped>
.center-title {
  position: absolute;
  top: 0;
  width: 100%;
  height: 320px;
  display: flex;
  padding: 150px 50px 0;
  background-image: url(../../../../../assets/parent/center-bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.center-content {
  margin-top: 260px;
  .van-cell-group-edit {
    margin-top: 20px;
  }
}
.center-icon,
.center-icon-default {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-right: 30px;
}
.center-icon-default {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #fff;
  background: #4196ff;
}
.center-name {
  font-weight: 700;
  font-size: 40px;
  color: #111;
}
.center-username {
  background: rgba(255, 117, 0, 0.1);
  border-radius: 10px 40px 40px 50px;
  font-size: 28px;
  color: #715745;
  padding: 10px 30px;
  margin-top: 20px;
}
.center-out {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  height: 80px;
  width: 54%;
  margin: 100px auto 0;
  border: 1px solid rgb(239, 106, 88);
  border-radius: 40px;
  background-color: rgb(255, 255, 255);
  color: rgb(239, 106, 88);
}
</style>
